import { Skeleton } from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/query';
import { FC, useEffect, useState } from 'react';
import { useGetHoleDetectionImageQuery } from 'store/_Api/HoleDetection';
import { ReactComponent as DownloadIcon } from 'atoms/icons/svg/download.svg';

type PropsType = {
  src: string;
  openImage: (link: string) => void;
};

const HoleDetectionImage: FC<PropsType> = ({ src, openImage }): JSX.Element => {
  const {
    data: imageBlob,
    error,
    isLoading,
  } = useGetHoleDetectionImageQuery(src ?? skipToken);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (imageBlob) {
      const url = URL.createObjectURL(imageBlob);
      setImageUrl(url);
      return () => URL.revokeObjectURL(url); // Clean up the URL when component unmounts
    }
  }, [imageBlob]);

  const downloadImage = (): void => {
    if (!imageUrl) {
      return;
    }

    try {
      const a = document.createElement('a');
      a.href = imageUrl;
      a.download = 'hole.jpg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the image:', error);
    }
  };

  if (error) {
    return <p>Error loading image</p>;
  }

  if (isLoading) {
    return <Skeleton className="gallery__placeholder" animation="wave" />;
  }

  if (!imageUrl) {
    return <></>;
  }

  return (
    <>
      <img
        src={imageUrl}
        alt={`Hole Detection Image`}
        className="gallery__thumbnail"
        onClick={() => openImage(imageUrl)}
      />

      <div className="download-icon">
        <DownloadIcon onClick={downloadImage} />
      </div>
    </>
  );
};

export default HoleDetectionImage;
